import type { Resource } from '../../';
export const country_countries_LU: Resource = {"default":"Luxembourg"};
